import { Box, InputAdornment } from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import CustomButton from '../inputs/CustomButton';
import CustomTextField from '../inputs/CustomTextField';

const StyledFormTitle = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: 'white',
  borderTopRightRadius: '5px',
  borderTopLeftRadius: '5px',
  padding: '11px 30px',
  borderBottom: `3px solid ${theme.palette.primary.main}`,
  overflowX: 'auto',
  color: theme.palette.primary.main,
  fontSize: '25px',
  fontWeight: 'bold',
  minHeight: '85px',
  alignContent: 'center',

  [theme.breakpoints.down('sm')]: {
    padding: '12px 20px',
    fontSize: '20px',
    flexDirection: 'column',
    gap: '10px',
    minHeight: 'auto',
  },

  [theme.breakpoints.down('xs')]: {
    padding: '10px 15px',
    fontSize: '18px',
  },
}));

const TitleText = styled(Box)(({ theme }) => ({
  fontSize: 'inherit',
  fontWeight: 'inherit',
  color: 'inherit',

  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    order: 1,
  },
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  [theme.breakpoints.down('sm')]: {
    order: 2,
    width: '100%',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 2,
    marginTop: 2,
  },
}));

const SearchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  maxHeight: '35px',
  [theme.breakpoints.down('sm')]: {
    maxHeight: 'none',
    width: '100%',
    marginBottom: '16px',
  },
}));

const FormTitleBox = ({
  title,
  buttonText,
  buttonIcon: ButtonIcon,
  onButtonClick,
  buttonProps = {},
  iconProps = {},
  showButton = false,
  isLoading = false,
  children,
  sx = {},
  // Search props
  showSearch = false,
  searchLabel = 'Buscar',
  searchValue = '',
  onSearchChange,
  searchPlaceholder = '',
  searchSize = 'medium',
  searchSx = {},
  searchInputProps = {},
  ...props
}) => {
  return (
    <StyledFormTitle sx={sx} {...props}>
      <TitleText>{title}</TitleText>

      {(showButton || showSearch || children) && (
        <ButtonContainer>
          {showSearch && (
            <SearchContainer>
              <CustomTextField
                label={searchLabel}
                value={searchValue}
                onChange={(e) => onSearchChange?.(e.target.value)}
                placeholder={searchPlaceholder}
                size={searchSize}
                sx={{
                  width: { xs: '100%', md: '300px' },
                  mt: 0,
                  mb: { xs: 0, md: 0 },
                  ...searchSx,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: 'primary.main' }} />
                    </InputAdornment>
                  ),
                  ...searchInputProps,
                }}
              />
            </SearchContainer>
          )}

          {showButton && buttonText && (
            <CustomButton
              variant={buttonProps.variant || 'base'}
              buttonIcon={ButtonIcon}
              onClick={onButtonClick}
              disabled={isLoading}
              iconProps={iconProps}
              sx={{
                paddingX: '20px',
                paddingY: '14px',
                fontSize: '16px',
                fontWeight: 'semibold',
                width: { xs: '100%', sm: 'auto' },
                ...buttonProps.sx,
              }}
              {...buttonProps}
            >
              {buttonText}
            </CustomButton>
          )}
          {children}
        </ButtonContainer>
      )}
    </StyledFormTitle>
  );
};

export default FormTitleBox;
